module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center2a"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("ALSO BY P. D. JAMES")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Death Comes to Pemberley")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Talking About Detective Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Lighthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Murder Room")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Death in Holy Orders")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Time to Be in Earnest: A Fragment of Autobiography")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A Certain Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Original Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Children of Men")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Devices and Desires")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A Taste for Death")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Skull Beneath the Skin")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Innocent Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Death of an Expert Witness")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Black Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Maul and the Pear Tree: The Ratcliffe Highway Murders, 1811")]), _vm._v(" (with T. A. Critchley)")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Shroud for a Nightingale")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Unnatural Causes")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A Mind to Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Cover Her Face")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ddafb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/a_fm03.vue
// module id = 72
// module chunks = 0